import { render } from "./OfficeTalentListCard.vue?vue&type=template&id=8dc1fa72&scoped=true&ts=true&lang=pug"
import script from "./OfficeTalentListCard.vue?vue&type=script&lang=ts"
export * from "./OfficeTalentListCard.vue?vue&type=script&lang=ts"

import "./OfficeTalentListCard.vue?vue&type=style&index=0&id=8dc1fa72&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc1fa72"]])

export default __exports__